import type { AppNode } from "./view-nodes.js";
import { text } from "./view-nodes.js";

/** Keep reading and keyboard order identical to the visual panel order. */
export function dashboard(
  content: readonly AppNode[],
  priority: readonly string[] = [],
): AppNode[] {
  const introduction: AppNode[] = [];
  const panels: { id: string; children: AppNode[] }[] = [];
  for (const node of content) {
    if (node.kind === "heading" && node.level === 3) panels.push({ id: node.id, children: [node] });
    else {
      const current = panels.at(-1);
      if (current) current.children.push(node);
      else introduction.push(node);
    }
  }
  const rank = (id: string) => {
    const index = priority.indexOf(id);
    return index < 0 ? priority.length : index;
  };
  panels.sort((a, b) => rank(a.id) - rank(b.id));
  return [
    ...introduction,
    {
      kind: "stack",
      id: "workspace-panels",
      style: { className: "kf-workspace" },
      children: panels.map((panel) => ({
        kind: "section",
        id: `${panel.id}-panel`,
        variant: "card",
        style: { className: "kf-panel" },
        children: panel.children,
      })),
    },
  ];
}

export function help(id: string, label: string, explanation: string): AppNode {
  return {
    kind: "help",
    id,
    label,
    triggerLabel: `i · ${label}`,
    presentation: "popover",
    preview: true,
    previewDelayMs: 120,
    previewMoveDismissPx: 24,
    content: [text(`${id}-text`, explanation)],
  };
}
